// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

// スマホヘッダーメニューの開閉
jQuery(function($){
  const spToggle = '.js-sp-gm-toggle';
  const spGm = '.js-sp-gm';
  const gmLogo = '.js-sp-gm-logo';
  $(spToggle).on('click',function(){
    $('header').toggleClass('is-active');
    $(this).toggleClass('is-active');
    $(spGm).slideToggle(300);
    $(gmLogo).toggleClass('is-active');
  })
})

// スマホフロートメニューの開閉
jQuery(function($){
  const toggle = '.js-sp-float-toggle';
  $(toggle).find('a').on('click',function(){
    $(this).parents('ul').toggleClass('is-active');
  })
})

// ページトップ
jQuery(function ($) {
  let pagetop = $('.js-page-top');
  pagetop.on('click',function () {
    $('body, html').animate({
        scrollTop: 0
    }, 500);
    return false;
  });
});

// スムーススクロール
jQuery(function($){
  $('a[href^="#"]').click(function(){
    // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
    var adjust = -100;
    // スクロールの速度（ミリ秒）
    var speed = 400;
    // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
    var href= $(this).attr("href");
    // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
    var position = target.offset().top + adjust;
    // スムーススクロール linear（等速） or swing（変速）
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  })
})
class Teaser {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const scrollMv = "." + this.el;
    // const trigger = '.js-teaser-mv-trigger';
    // gsap.to(scrollMv,{
    //   scrollTrigger: {
    //     trigger: trigger,
    //     start: "bottom 80%",
    //     toggleActions: 'none none none none',
    //     toggleClass: {targets: scrollMv, className: 'is-active'},
    //   }
    // })
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mvSwiper = new Swiper('.js-home-mv-slider', {
      speed: 500,
      slidesPerView: 1.1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      breakpoints: {
        851: {
          slidesPerView: 1.58,
        }
      }
    })

    if(isMobile()){

    }else{
      const casesSwiper = new Swiper('.js-home-cases-slider', {
        speed: 500,
        slidesPerView: 1.1,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
          851: {
            slidesPerView: 2.4,
          }
        }
      })
    }
  }
}

class AboutModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalOpen = '.js-about-modal-open';
    const modalWrap = '.js-about-modal';
    const modalContent = '.js-about-modal-content';
    const modalClose = '.js-about-modal-close';
    $(modalOpen).on('click',function(){
      let modalNum = $(this).data('num');
      $(modalContent+':eq('+modalNum+')').css('display','flex');
      $(modalWrap).fadeIn().scrollTop(0);
    })
    $(modalClose).on('click',function(){
      $(modalWrap).fadeOut();
      $(modalContent).fadeOut();
    })
  }
}
// config
var APP = {
	bp: {
		mobile: 850
	}
};

var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class ContactCheckBox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).find('input[type=checkbox],input[type=radio]').each(function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=checkbox]').on('change',function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=radio]').on('change',function(){
      let radioName = $(this).attr('name');
      $('[name='+radioName+']').each(function(){
        if($(this).prop('checked') == true){
          $(this).parent('label').addClass('is-active');
        }else{
          $(this).parent('label').removeClass('is-active');
        }
      })
    })
  }
}

class ContactSelect {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const Select = $('.js-contact-select');
    $(Select).find('select').on('change', function(){
      if ($(this).val() !== ""){
        $(Select).removeClass('is-empty');
      } else {
        $(Select).addClass('is-empty');
      }
    });

    // URLからクエリパラメータを取得する関数
    function getQueryParam(param) {
      var searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(param);
    }

     // ページロード時に実行
  var programIndex = getQueryParam('program'); // 'program'パラメータの値を取得
  if (programIndex) {
    var selectContainers = document.querySelectorAll('.js-contact-select'); // '.js-contact-select'クラスを持つ全ての要素を取得
    selectContainers.forEach(function(container) {
      container.classList.remove('is-empty'); // 'is-empty'クラスを削除
    });

    var selectElements = document.querySelectorAll('.js-contact-select select'); // '.js-contact-select'内の全てのselect要素を取得
    selectElements.forEach(function(selectElement) {
      var index = parseInt(programIndex, 10);
      if (selectElement.options[index]) {
        selectElement.selectedIndex = index; // セレクトボックスのインデックスを設定
      }
    });
  }

  }
}

class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class FloatToc {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const toggleNav = '.js-float-toc';

  $('.js-toc-toggle').each(function(index) {
    applyScrollTrigger($(this), index);
  });

  function applyScrollTrigger(toggleSection, index) {
    if($(toggleNav).length){
      gsap.to(toggleNav, { 
        scrollTrigger: {
          trigger: toggleSection,
          start: 'top center',
          onEnter: () => setNavItemActive(index),
          onEnterBack: () => setNavItemActive(index)
        },
      });
    }
  }

  function setNavItemActive(index) {
    $(toggleNav).find('li').removeClass('is-active');
    $(toggleNav).find('li').eq(index).addClass('is-active');
  }
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class MoreInterview {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var page = 2; //初期ページ番号
    $("." + this.el).on('click', function (e) {
      e.preventDefault();
      let pcat = $(this).attr('data-cat');
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
          action: 'load_more_interview',
          page: page,
          pcat: pcat
        },
        success: function (response) {
          var data = JSON.parse(response);
            $('.js-more-interview-contents').append('<div style="display:none;" class="new-posts">' + data.content + '</div>');
            $('.new-posts').fadeIn('slow');
          if (!data.hasMorePosts) {
              $('.js-more-interview').fadeOut();
          } else {
              page++;
          }
        }
      });
    });
  }
}
class MoreNews {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var page = 2; //初期ページ番号
    $("." + this.el).on('click', function (e) {
      e.preventDefault();
      let pcat = $(this).attr('data-cat');
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
          action: 'load_more_news',
          page: page,
          pcat: pcat
        },
        success: function (response) {
          var data = JSON.parse(response);
            $('.js-more-news-contents').append('<div style="display:none;" class="new-posts">' + data.content + '</div>');
            $('.new-posts').fadeIn('slow');
          if (!data.hasMorePosts) {
              $('.js-more-news').fadeOut();
          } else {
              page++;
          }
        }
      });
    });
  }
}
class MoreSeminar {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var page = 2; //初期ページ番号
    $("." + this.el).on('click', function (e) {
      e.preventDefault();
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
          action: 'load_more_seminar',
          page: page,
        },
        success: function (response) {
          var data = JSON.parse(response);
            $('.js-more-seminar-contents').append('<div style="display:none;" class="new-posts">' + data.content + '</div>');
            $('.new-posts').fadeIn('slow');
          if (!data.hasMorePosts) {
              $('.js-more-seminar').fadeOut();
          } else {
              page++;
          }
        }
      });
    });
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let top = new Top('js-home');
  let teaser = new Teaser('js-teaser-mv-scroll');
  let floatToc = new FloatToc('js-float-toc');
  let contactCheckbox = new ContactCheckBox('js-contact-checkbox');
  let contactSelect = new ContactSelect('js-contact-select');
  let moreNews = new MoreNews('js-more-news');
  let moreInterview = new MoreInterview('js-more-interview');
  let moreSeminar = new MoreSeminar('js-more-seminar');

  // about（私たちについて）ページ用
  let aboutModal = new AboutModal('js-about-modal');

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });